import Immutable from 'immutable'

export const SupplementalFile = Immutable.Record({
  id: null,
  partId: null,
  filename: ''
});

export const SupplementalFileMap = Immutable.OrderedMap;